// Tallennusavaimet ja niiden luku/kirjoitus. Avainten nimet ovat sopimus:
// ne on dokumentoitu docs/tietosuoja/tallennusavaimet.md:hen eikä niitä saa
// nimetä uudelleen vaiheessa 1 (ml. cmp_visitor_id, ks. PL-5).

import type { Choices, StoredConsent } from './types';

export const VISITOR_ID_KEY = 'cmp_visitor_id';

export function consentKey(domain: string): string {
  return 'cmp_consent_' + domain;
}

export function consentIdKey(domain: string): string {
  return 'cmp_consent_id_' + domain;
}

export function gcmKey(domain: string): string {
  return 'cmp_gcm_' + domain;
}

export function patternsKey(domain: string): string {
  return 'cmp_patterns_' + domain;
}

/** Tallennettu suostumus tai null (myös jos localStorage ei ole käytettävissä). */
export function getStoredConsent(domain: string): StoredConsent | null {
  try {
    return JSON.parse(localStorage.getItem(consentKey(domain)) as string);
  } catch {
    return null;
  }
}

/** Tallennetun suostumuksen valinnat tai null (inline-blokkerin lukutapa). */
export function getStoredChoices(domain: string): Choices | null {
  let c: Choices | null = null;
  try {
    c = (JSON.parse(localStorage.getItem(consentKey(domain)) as string) as StoredConsent).choices ?? null;
  } catch {
    // ei tallennettua suostumusta
  }
  return c;
}

export function storeConsent(domain: string, choices: Choices, action: string): void {
  localStorage.setItem(consentKey(domain), JSON.stringify({ choices, action, ts: Date.now() }));
}

/**
 * Suostumuksen todistustunnuksen viitteenä käytettävä kävijätunnus.
 * HUOM: luodaan vasta kun valinta lähetetään (sendConsent) — ei sivulatauksessa.
 */
export function getVisitorId(): string {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = 'v_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
}

export function getConsentId(domain: string): string | null {
  return localStorage.getItem(consentIdKey(domain));
}

export function storeConsentId(domain: string, consentId: string): void {
  localStorage.setItem(consentIdKey(domain), consentId);
}
